var map = {
	"./1Parcitipante.svg": "ML2t",
	"./2Participantes.svg": "qpWG",
	"./Advance.svg": "qBVx",
	"./AlertRounded.svg": "ZQj4",
	"./Alerta2.svg": "nC2X",
	"./Arrow.svg": "GP5L",
	"./ArrowCircle.svg": "nctr",
	"./ArrowCircleBottom.svg": "bFRi",
	"./ArrowCircleTop.svg": "nTWo",
	"./Attachment.svg": "6ot5",
	"./Bank.svg": "+rys",
	"./Birthday.svg": "0E9+",
	"./Box.svg": "cBni",
	"./Calendar.svg": "qcQo",
	"./Calendar2.svg": "AzR8",
	"./Calendar_Days.svg": "FoIW",
	"./Camera.svg": "0vGy",
	"./Carrito.svg": "2ID6",
	"./Cart.svg": "5sBs",
	"./Cash.svg": "y8E2",
	"./Category.svg": "cXIp",
	"./ChangeGift Copy.svg": "YQ/Z",
	"./ChangeGiftCopy.svg": "jzua",
	"./Chevron.svg": "B4n1",
	"./Clipboard.svg": "YsNH",
	"./Clock_LDR.svg": "NsOR",
	"./Close.svg": "4PFj",
	"./Compare-white.svg": "IdJ2",
	"./Compare.svg": "vi32",
	"./Computer.svg": "tKMm",
	"./Conver.svg": "eMOB",
	"./Copy.svg": "xwrr",
	"./Corporate.svg": "MMjw",
	"./Credit.svg": "J/5W",
	"./Debit.svg": "nAws",
	"./Descuento.svg": "Vicx",
	"./DowloadDocument.svg": "BBjH",
	"./Download.svg": "W40y",
	"./Ellipse.svg": "SmSd",
	"./Email2.svg": "QfCL",
	"./Error.svg": "UJyq",
	"./Eye.svg": "yoQB",
	"./Facebook.svg": "41M6",
	"./FacebookFilled.svg": "9kcE",
	"./Filter.svg": "odPB",
	"./Gift.svg": "M03t",
	"./Gift2.svg": "7KSu",
	"./Google.svg": "3NrH",
	"./GreenOk.svg": "4tbc",
	"./HamburgerMenu.svg": "dS3m",
	"./HandUp.svg": "Rlaa",
	"./Hat.svg": "iD2a",
	"./Heart.svg": "2QM/",
	"./Hearth.svg": "eSQa",
	"./House.svg": "vPT1",
	"./Important.svg": "pcTT",
	"./Information.svg": "NgXg",
	"./Lamp.svg": "iKI1",
	"./Like.svg": "0qCT",
	"./Location.svg": "2Imb",
	"./LocationThree.svg": "TJY3",
	"./LocationTwo.svg": "tU9t",
	"./Location_LDR.svg": "OxIB",
	"./Lock.svg": "H7KP",
	"./LolFace.svg": "gSH+",
	"./Luggage.svg": "9+pU",
	"./Mail.svg": "NGA9",
	"./Map.svg": "P0w8",
	"./Market.svg": "yrY2",
	"./MasParticipantes.svg": "lFBD",
	"./Microphone.svg": "QMFH",
	"./Minus.svg": "0+iK",
	"./More.svg": "4e71",
	"./Notification.svg": "SLLa",
	"./Ok.svg": "91e1",
	"./Oval.svg": "UXv3",
	"./OvalDark.svg": "X3kZ",
	"./Page 1.svg": "W13X",
	"./Page1.svg": "bi9f",
	"./Pappers.svg": "lqFo",
	"./Phone.svg": "kFcq",
	"./Phone2.svg": "yKAY",
	"./Play.svg": "4TLN",
	"./Plus.svg": "7iO+",
	"./QR.svg": "ZPqY",
	"./Question.svg": "fwMb",
	"./Reglas.svg": "4oM4",
	"./Reservation.svg": "MxK2",
	"./ReturnGif.svg": "E90B",
	"./Ring.svg": "KRc+",
	"./SabiasQue.svg": "3cnU",
	"./Safe.svg": "WaqD",
	"./Search.svg": "ixuE",
	"./Send.svg": "Mvc1",
	"./Share.svg": "s2Bb",
	"./Smile.svg": "x/jK",
	"./Spark.svg": "npPT",
	"./Star.svg": "5hhi",
	"./StarFill.svg": "69qM",
	"./StarGray.svg": "5T3a",
	"./Subtract.svg": "Kw0O",
	"./TarjetaBox.svg": "G00h",
	"./Tick.svg": "QAr+",
	"./Time.svg": "QRBG",
	"./Timer.svg": "mq9t",
	"./TouchHand.svg": "exWx",
	"./Trash.svg": "WOyl",
	"./Trophy.svg": "DbfG",
	"./Truck.svg": "AxZ8",
	"./Union.svg": "iMSb",
	"./Upload.svg": "Csv3",
	"./User.svg": "0DoO",
	"./User2.svg": "Z4ll",
	"./User3.svg": "KDnl",
	"./Userx3.svg": "36Pw",
	"./Virus.svg": "sL5r",
	"./WhatsApp.svg": "bkSl",
	"./X.svg": "8Ami",
	"./amex.svg": "rjmR",
	"./bad.svg": "Vqkk",
	"./bigbox.svg": "eXnz",
	"./casitis.svg": "KZsq",
	"./checkcircle.svg": "jdDn",
	"./clock.svg": "PP2n",
	"./debvisa.svg": "ioxH",
	"./delivery-person.svg": "ni9O",
	"./dragAndCut.svg": "5l3W",
	"./edit.svg": "/IoP",
	"./fullheart.svg": "WV7r",
	"./good.svg": "xZba",
	"./home.svg": "OWim",
	"./imageicon.svg": "guyQ",
	"./instagram.svg": "xvG5",
	"./master.svg": "KNGN",
	"./neutral.svg": "AAHY",
	"./ok_2.svg": "Az2D",
	"./openSign.svg": "AlZi",
	"./options.svg": "Waii",
	"./other.svg": "jRhf",
	"./outlined-bell.svg": "G5Ua",
	"./perfil.svg": "7jpf",
	"./puntodeventa.svg": "kAIY",
	"./rating.svg": "GoRM",
	"./reception-bell.svg": "8Sg4",
	"./sellspot.svg": "O4I2",
	"./sliderController.svg": "LQU9",
	"./sort.svg": "lfqV",
	"./take-away.svg": "nVE0",
	"./thinCloseIcon.svg": "ijZ2",
	"./veryBad.svg": "EStg",
	"./veryGood.svg": "KmTy",
	"./visa.svg": "H9Ab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "P+R+";